import { Link } from "react-router-dom";

export default function Wordmark({ dark = false }) {
  return (
    <Link to="/" data-testid="wordmark-home-link" className="group inline-flex flex-col leading-none">
      <span
        className={`font-serif text-lg sm:text-xl tracking-[0.14em] font-semibold flex items-center gap-1.5 ${
          dark ? "text-ivory" : "text-navy"
        }`}
      >
        VENTURE
        <span className="relative inline-flex items-center justify-center text-gold italic font-normal">
          &
          <svg
            viewBox="0 0 24 24"
            className="absolute -top-1.5 -right-2 h-2.5 w-2.5 text-gold transition-transform duration-500 group-hover:rotate-45"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
          </svg>
        </span>
        STAY
      </span>
      <span
        className={`text-[9px] sm:text-[10px] tracking-[0.22em] uppercase mt-1 ${
          dark ? "text-ivory/60" : "text-slateblue"
        }`}
      >
        Better journeys, thoughtfully planned
      </span>
    </Link>
  );
}
